import { render, staticRenderFns } from "./directRK.vue?vue&type=template&id=dbc99ffa&scoped=true&"
import script from "./directRK.vue?vue&type=script&lang=js&"
export * from "./directRK.vue?vue&type=script&lang=js&"
import style0 from "./directRK.vue?vue&type=style&index=0&id=dbc99ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc99ffa",
  null
  
)

export default component.exports